import { useThemedMarkdownStyle } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.description";
import { MorphemeMnemonicsMeaningViewContext } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._views.grapheme.mnemonics._components.panel-content.views.meaning._context";
import { useGraphemeLinkPress } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.preview-sheet";
import { StyleSheet } from "@-/com.npmjs.react-native";
import { EnrichedMarkdownText } from "@-/com.npmjs.react-native-enriched-markdown";
import { useContext } from "react";
import { useAbsentMnemonicDescription } from "#use-absent-mnemonic-description";

const styles = StyleSheet.create({
  mnemonicBody: { fontSize: 14, lineHeight: 22 },
});

/**
 * The generated `_part_ + _part_ = term` stand-in, rendered in the mnemonic slot when no
 * authored mnemonic exists. It stands in for the mnemonic itself, so it belongs with the
 * absent-mnemonic explainer and suggest button rather than as a separate heading.
 */
export function AbsentMnemonicFallbackRenderer() {
  const { componentList, grapheme, markdown } = useAbsentMnemonicDescription();
  const { morphemeHrefObject } = useContext(MorphemeMnemonicsMeaningViewContext);
  const onGraphemeLinkPress = useGraphemeLinkPress({ prefix: morphemeHrefObject });
  const markdownStyle = useThemedMarkdownStyle();

  return (
    <EnrichedMarkdownText
      containerStyle={styles.mnemonicBody}
      markdown={markdown}
      markdownStyle={markdownStyle}
      onLinkPress={({ url }) => {
        let decodedUrl: string;
        try {
          decodedUrl = decodeURIComponent(url);
        } catch {
          return;
        }
        const linkedGrapheme = decodedUrl === "." ? grapheme : decodedUrl;
        if (
          linkedGrapheme !== grapheme &&
          !componentList.some((component) => component.grapheme === linkedGrapheme)
        ) {
          return;
        }
        onGraphemeLinkPress(linkedGrapheme);
      }}
    />
  );
}
